import { get } from 'lodash';
import React, { useState } from 'react';
import { Field } from 'redux-form';
import { getCurrentValue } from '../../ChargerConfigurationHelper';
import { accessLevels, controllerTypes } from '../../constants';
import { clearBatchUpdateButtonComponent, clearButtonComponent, getFieldComponent, getValidations } from './utils';

const ConfigurationFieldComponent = (props) => {
  const {
    parameter: {
      description,
      available_values: availableValues = [],
      access_mode: accessMode,
      status,
      validation,
      value,
      controller_type: controllerType,
      data_type: dataType,
    },
    fieldName,
    labelText,
    readOnly,
    onFieldChange,
    resetField,
    cancelChanges,
    isBatchUpdate,
    onBatchFieldChange,
    isModal,
  } = props;

  const [isShouldValidate, setIsShouldValidate] = useState(true);

  const fieldComponent = getFieldComponent(controllerType, dataType, availableValues);
  const currentValue = getCurrentValue(controllerType, availableValues, value);

  const isReadOnly = readOnly || accessMode === accessLevels.readOnly;

  const fieldValidation = getValidations(validation);

  const inputProps = get(validation, 'range')
    ? {
        inputProps: {
          min: validation.range.min,
          max: validation.range.max,
        },
      }
    : null;
  const type = controllerType === controllerTypes.number || get(validation, 'range') ? 'number' : null;
  const normalizer = null;

  const onClickCallback = isModal ? () => setIsShouldValidate(false) : null;
  const clearButton = clearButtonComponent(isReadOnly, resetField, cancelChanges, onClickCallback);
  const batchUpdateButton = clearBatchUpdateButtonComponent(onBatchFieldChange);

  return (
    <div className="field-row">
      <div className="field-container">
        <Field
          key={fieldName}
          label={labelText}
          name={fieldName}
          disabled={isReadOnly}
          description={description}
          status={status}
          currentValue={currentValue}
          inputProps={inputProps}
          onFieldChange={onFieldChange}
          type={type}
          multiple={controllerType === controllerTypes.multi_select}
          multiline={controllerType === controllerTypes.text_area}
          normalize={normalizer}
          component={fieldComponent}
          defaultValue={value}
          clearButton={clearButton}
          options={availableValues}
          validate={isShouldValidate ? fieldValidation : null}
          isBatchUpdate={isBatchUpdate}
          batchUpdateButton={batchUpdateButton}
          isModal={isModal}
          onBatchFieldChange={onBatchFieldChange}
          setIsShouldValidate={setIsShouldValidate}
        />
      </div>
    </div>
  );
};

export default ConfigurationFieldComponent;
